import React from "react"
import LoginPanel from "../../../features/authentication/components/LoginPanel"
import NewUserPanel from "../../../features/authentication/components/NewUserPanel"
import { RedirectIfAuthenticated } from "../../../features/authentication/redirects"
import { useQueryParam } from "../../../features/navigation/hooks/useQueryParam"
import Stroke from "../../../ui/atoms/Stroke"
import { CustomCol, CustomContainer, CustomRow } from "../../../ui/spacings"

interface Props {
  contents: any
}

const LoginPageContainer = ({ contents }: Props) => {
  console.log("c", contents)
  const redirectUrl = useQueryParam("returnUrl")
  return (
    <>
      {!redirectUrl && <RedirectIfAuthenticated to="/profile" />}
      <CustomContainer className="my-10 sm:my-24">
        <CustomRow justify="center">
          <CustomCol xs={12} sm={5}>
            <div className="px-6">
              <LoginPanel />
            </div>
            <Stroke color="disabled" className="my-4" />
            <div className="px-6">
              <NewUserPanel />
            </div>
            {/* <LoginForm redirectUrl={redirectUrl} />
            <div className="mt-6">
              <Link href={forgotPasswordPagePath} passHref>
                <a>
                  <EditorialLabel
                    scope="account"
                    id="forgot-password"
                    variant="subtitle2"
                  />
                </a>
              </Link>
            </div>
            <CustomBox my={2} textCenter>
              <TwRichTextField
                value={contents.data.contents.registrationLinkDescription}
              />
              <Link href={registrationPagePath} passHref>
                <a>
                  <CustomButton variant="text">
                    {contents.data.contents.registrationLinkName}
                  </CustomButton>
                </a>
              </Link>
            </CustomBox> */}
          </CustomCol>
        </CustomRow>
      </CustomContainer>
    </>
  )
}

LoginPageContainer.defaultProps = {
  redirectUrl: "/",
}

export default LoginPageContainer
